import fetch from 'node-fetch';

interface AddressRiskIndicator {
  category: string;
  categoryId: string;
  categoryRiskScoreLevel: number;
  categoryRiskScoreLevelLabel: string;
  incomingVolumeUsd: string;
  outgoingVolumeUsd: string;
  riskType: string;
  totalVolumeUsd: string;
}

interface Entity {
  category: string;
  categoryId: string;
  entity: string;
  riskScoreLevel: number;
  riskScoreLevelLabel: string;
  trmAppUrl: string;
  trmUrn: string;
}

interface TRMResponse {
  accountExternalId: string;
  address: string;
  addressRiskIndicators: Array<AddressRiskIndicator>;
  addressSubmitted: string;
  chain: string;
  entities: Array<Entity>;
  trmAppUrl: string;
}

export const WALLET_SCREEN_FAILURE_ERROR =
  'This address has been flagged by TRM as a high risk address. Please contact us at support@magna.so if you believe this is an error.' as string;

export const trm = async (address: string) => {
  try {
    const payload: any = [
      {
        address: address,
        chain: process.env.NEXT_PUBLIC_CHAIN.toLowerCase(),
      },
    ];

    const resp = await fetch(`https://api.trmlabs.com/public/v2/screening/addresses`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Basic ' +
          Buffer.from(process.env.NEXT_PUBLIC_TRM_KEY + ':' + process.env.NEXT_PUBLIC_TRM_KEY).toString('base64'),
      },
      body: JSON.stringify(payload),
    });

    const data: Array<TRMResponse> = await resp.json();

    // we return this in the situation where a wallet has no trm data
    if (data === undefined) return true;

    // Loop through addressRiskIndicators array in response
    for (let i = 0; i < data[0].addressRiskIndicators.length; i++) {
      // If ANY objects have riskType `OWNERSHIP` and categoryRiskScoreLevelLabel `High`
      if (
        data[0].addressRiskIndicators[i].riskType === 'OWNERSHIP' &&
        data[0].addressRiskIndicators[i].categoryRiskScoreLevelLabel === 'High'
      ) {
        return false;
      }
    }

    return true;
  } catch (error: any) {
    throw Error(error.message);
  }
};
